module.exports = {
	catagory: 'brewing equipment',
	defaultImage: "https://images.unsplash.com/photo-1548386581-23b700b33be0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1770&q=80",
	questions: [

		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"porcelain teapot"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"clay teapot",
					"shiboridashi",
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://ia600708.us.archive.org/21/items/clevelandart-2009.105-teapot/2009.105_full.jpg`
		},
		{
			questionText: `What is the benefit of using a porcelain teapot?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					'does not hold flavor'
				],
				incorrect: [
					"",
					"",
					"",
					"",
					"",
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://ia600708.us.archive.org/21/items/clevelandart-2009.105-teapot/2009.105_full.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"unglased clay teapot"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"porcelain teapot",
					"shiboridashi",
				]
			},
			response: `The invention of the teapot is often credited to potters working in the Yixing district of Jiangsu Province sometime in the sixteenth century.`,
			tags: [""],
			citations: `https://www.metmuseum.org/art/collection/search/42323`,
			image: `https://images.metmuseum.org/CRDImages/as/original/DP342745.jpg`
		},
		{
			questionText: `What is the benefit of using a clay teapot?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"high heat retention"
				],
				incorrect: [
					"",
					"",
					"",
					"",
					"",
				]
			},
			response: `Unglased teapots have fantastic heat retention properties. The flavor of the pot changes with use. An unglased clay teapot used for green tea should not be used for brewing black tea.`,
			tags: [""],
			citations: `https://www.metmuseum.org/art/collection/search/42323`,
			image: `https://images.metmuseum.org/CRDImages/as/original/DP342745.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"brew basket"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"shiboridashi",
				]
			},
			response: ``,
			tags: [""],
			citations: `https://i.stack.imgur.com/Elako.jpg`,
			image: `https://i.stack.imgur.com/Elako.jpg`
		},
		{
			questionText: `What is the benefit of using a brew basket?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"ease of use"
				],
				incorrect: [
					"brews the best tea",
					"stylish",
				]
			},
			response: `Brew any tea with ease.`,
			tags: [""],
			citations: `https://commons.wikimedia.org/wiki/File:Tea_ball.jpg`,
			image: `https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Tea_ball.jpg/800px-Tea_ball.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"silver teapot"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"shiboridashi",
				]
			},
			response: ``,
			tags: [""],
			citations: `https://www.metmuseum.org/art/collection/search/702890`,
			image: `https://collectionapi.metmuseum.org/api/collection/v1/iiif/702890/1798180/main-image`
		},
		{
			questionText: `What is the benefit of using a silver teapot?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"non-reactive"
				],
				incorrect: [
					"",
					"",
					"",
					"",
					"",
				]
			},
			response: ``,
			tags: [""],
			citations: `https://www.metmuseum.org/art/collection/search/702890, https://www.lenntech.com/periodic/water/silver/silver-and-water.htm`,
			image: `https://collectionapi.metmuseum.org/api/collection/v1/iiif/702890/1798180/main-image`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"glass teapot"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"shiboridashi",
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://live.staticflickr.com/1876/44459331652_6ca467e26f_b.jpg`
		},
		{
			questionText: `What is the benefit of using a glass teapot?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"cools down quickly"
				],
				incorrect: [
					"",
					"",
					"",
					"",
					"",
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://live.staticflickr.com/1876/44459331652_6ca467e26f_b.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"gaiwan"
				],
				incorrect: [
					"kyusu",
					"yuzamashi",
					"clay teapot",
					"shiboridashi",
				]
			},
			response: ``,
			tags: ["gaiwan", "chinese", ],
			citations: ``,
			image: `https://images.unsplash.com/photo-1609321979677-66f6f757b31d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80`
		},
		{
			questionText: `What is the benefit of using a gaiwan?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"easy to clean"
				],
				incorrect: [
					"for brewing Japanese tea",
					"cool down hot water",
					"brewing tiny broken up leaves",
					"easy to use",
				]
			},
			response: `A gaiwan is is suitable to brewing whole leaf tea and is very easy to clean. Because a gaiwan does not hold flavor it is ideal for sampling tea.`,
			tags: ["gaiwan", "chinese", ],
			citations: ``,
			image: `https://images.unsplash.com/photo-1609321979677-66f6f757b31d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"kyusu"
				],
				incorrect: [
					"gaiwan",
					"yuzamashi",
					"silver teapot",
					"shiboridashi",
				]
			},
			response: `A kyusu is especially suited to brewing Japanese Sencha. Their filtration of fine partials is second to none.`,
			tags: ["japanese", "sencha", "kyusu", "hojicha"],
			citations: ``,
			image: `https://photo.kniebes.com/media/2019/02/20190207-kyusu.jpg`
		},
		{
			questionText: `What tea is brewed using a kyusu?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Japanese tea"
				],
				incorrect: [
					"Indian tea",
					"Chinese tea",
					"Korean tea",
					"Iranian tea",
					"English tea",
				]
			},
			response: ``,
			tags: ["japanese", "sencha", "kyusu", "hojicha"],
			citations: ``,
			image: `https://photo.kniebes.com/media/2019/02/20190207-kyusu.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"yuzamashi"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"shiboridashi",
				]
			},
			response: ``,
			tags: ["japanese", "sencha"],
			citations: `https://teapedia.org/eng/images/thumb/2/2a/Yuzamashi.jpg/500px-Yuzamashi.jpg`,
			image: `https://teapedia.org/eng/images/thumb/2/2a/Yuzamashi.jpg/500px-Yuzamashi.jpg`
		},
		{
			questionText: `What is the benefit of using a yuzamashi?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"cooling water"
				],
				incorrect: [
					"serving tea",
					"heating water",
					"brewing tea",
					"drinking tea",
				]
			},
			response: `Yuamashi means literally "hot water cooler".`,
			tags: [""],
			citations: `https://teapedia.org/eng/images/thumb/2/2a/Yuzamashi.jpg/500px-Yuzamashi.jpg`,
			image: `https://teapedia.org/eng/images/thumb/2/2a/Yuzamashi.jpg/500px-Yuzamashi.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"gongdaobei",
					"公道杯"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"shiboridashi",
				]
			},
			response: `Gongdaobei literally means "public method cup" and is often called a "fair pour".`,
			tags: [""],
			citations: `https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chaju_shizuhaused_09.jpg/400px-Chaju_shizuhaused_09.jpg`,
			image: `https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chaju_shizuhaused_09.jpg/400px-Chaju_shizuhaused_09.jpg`
		},
		{
			questionText: `What is the benefit of using a gongdaobei?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"serving tea"
				],
				incorrect: [
					"brewing tea",
					"heating water",
					"drinking tea",
				]
			},
			response: `Using a gongdaobei one can decant tea while waiting for the perfect serving temperature.`,
			tags: [""],
			citations: `https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chaju_shizuhaused_09.jpg/400px-Chaju_shizuhaused_09.jpg`,
			image: `https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chaju_shizuhaused_09.jpg/400px-Chaju_shizuhaused_09.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"shiboridashi"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"porcelain teapot",
					"clay teapot",
					"glass teapot",
					"brew basket",
					"silver teapot",
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://photo.kniebes.com/media/2019/04/white-bing-cha-2016-00002.jpg`
		},
		{
			questionText: `What tea is brewed with a shiboridashi?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"gyokuro"
				],
				incorrect: [
					"iron goddess",
					"sencha",
					"hojicha",
					"darjeeling",
					"black tea"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: `https://photo.kniebes.com/media/2019/04/white-bing-cha-2016-00002.jpg`
		},
		{
			questionText: `What is the name of this object?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"ISO 3103 cup/bowls"
				],
				incorrect: [
					"gaiwan",
					"kyusu",
					"yuzamashi",
					"porcelain teapot",
					"clay teapot",
					"glass teapot",
					"brew basket",
					"silver teapot",
				]
			},
			response: ``,
			tags: [""],
			citations: `https://en.wikipedia.org/wiki/ISO_3103`,
			image: `https://internet-law.ru/gosts/Data/571/57173/5.png`
		},
		{
			questionText: `What is the benefit of using a ISO 3103 cup/bowls?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"standardization"
				],
				incorrect: [
					"best flavor",
					"cheap",
					"stylish",
				]
			},
			response: `ISO 3103 cups are made to exact specifications in order to create a reproducible cup of tea.`,
			tags: [""],
			citations: `https://en.wikipedia.org/wiki/ISO_3103`,
			image: `https://internet-law.ru/gosts/Data/571/57173/5.png`
		},
	]
}


		// {
		// 	questionText: `What is the name of this object?`,
		// 	questionDifficulty: 1,
		// 	answerOptions: {
		// 		correct: [
		// 			""
		// 		],
		// 		incorrect: [
		// 		]
		// 	},
		// 	response: ``,
		// 	tags: [""],
		// 	citations: ``,
		// 	image: ``
		// },